import type { GetCustomAttributeSchemaAuditByIdResponseRow } from '@risksmart-app/drizzle/src/dto';
import { GetCustomAttributeSchemaAuditByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

import type { AuditLogQueryResult } from './auditLogQueryResult';

type UseGetCustomAttributeSchemaAuditByIdArgs = { id: string };

export const useGetCustomAttributeSchemaAuditById = createQueryHook<
  UseGetCustomAttributeSchemaAuditByIdArgs,
  GetCustomAttributeSchemaAuditByIdResponseRow[],
  AuditLogQueryResult<
    'custom_attribute_schema_audit',
    GetCustomAttributeSchemaAuditByIdResponseRow
  >
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.auditLog.getCustomAttributeSchemaAuditById.queryOptions({
      id,
    }),
  mapTrpcDataToGraphQL: (data) => ({
    custom_attribute_schema_audit: data || [],
  }),
  graphqlDocument: GetCustomAttributeSchemaAuditByIdDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
});
